import { WarningRounded } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

interface ReissuedInvoiceWarningProps {
    tooltipTitle: string;
}

const ReissuedInvoiceWarning: React.FC<ReissuedInvoiceWarningProps> = ({ tooltipTitle }) => {
    return (
        <Tooltip title={tooltipTitle}>
            <WarningRounded color="warning" />
        </Tooltip>
    );
};

export default ReissuedInvoiceWarning;
